import { useState } from 'react';
import { useCancelChargeMutation } from '../../services/receiptApi/receiptApi';
export function useChargeCancellation({ onSuccess, onError, } = {}) {
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [cancelCharge, { isLoading }] = useCancelChargeMutation();
    const openCancelModal = () => {
        setIsCancelModalOpen(true);
    };
    const closeCancelModal = () => {
        setIsCancelModalOpen(false);
    };
    const confirmCancellation = async (chargeId) => {
        try {
            await cancelCharge({ chargeId }).unwrap();
            setIsCancelModalOpen(false);
            setShowSuccessAlert(true);
            onSuccess?.(chargeId);
        }
        catch (error) {
            setIsCancelModalOpen(false);
            setShowErrorAlert(true);
            onError?.(error, chargeId);
        }
    };
    const closeSuccessAlert = () => {
        setShowSuccessAlert(false);
    };
    const closeErrorAlert = () => {
        setShowErrorAlert(false);
    };
    return {
        isCancelModalOpen,
        isLoading,
        showSuccessAlert,
        showErrorAlert,
        openCancelModal,
        closeCancelModal,
        confirmCancellation,
        closeSuccessAlert,
        closeErrorAlert,
    };
}
